/**
 * @generated SignedSource<<a8bc263fc17c7fa8c3460c4101f227b4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useFabricEligibilityMigrationQuery_content$data = {
  readonly id: string | null;
  readonly metadata: {
    readonly frontend: {
      readonly contentHash: string | null;
      readonly fabricEditorEligibility: string | null;
    } | null;
  };
  readonly " $fragmentType": "useFabricEligibilityMigrationQuery_content";
};
export type useFabricEligibilityMigrationQuery_content$key = {
  readonly " $data"?: useFabricEligibilityMigrationQuery_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"useFabricEligibilityMigrationQuery_content">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "useFabricEligibilityMigrationQuery_content",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "concreteType": "ContentMetadata",
      "kind": "LinkedField",
      "name": "metadata",
      "plural": false,
      "selections": [
        {
          "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
          "kind": "LinkedField",
          "name": "frontend",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "fabricEditorEligibility"
            },
            {
              "kind": "ScalarField",
              "name": "contentHash"
            }
          ]
        }
      ]
    }
  ],
  "type": "Content"
};

(node as any).hash = "298bfce8c2c4eb82f3dc52164035b637";

export default node;
